__turbopack_context__.v({
  "arrowCol": "LorryCard-module-scss-module__pHnz5G__arrowCol",
  "awaiting": "LorryCard-module-scss-module__pHnz5G__awaiting",
  "bidStatus": "LorryCard-module-scss-module__pHnz5G__bidStatus",
  "bidStatusContainer": "LorryCard-module-scss-module__pHnz5G__bidStatusContainer",
  "bidStatusIndicator": "LorryCard-module-scss-module__pHnz5G__bidStatusIndicator",
  "editAndComment": "LorryCard-module-scss-module__pHnz5G__editAndComment",
  "editAndCommentContainer": "LorryCard-module-scss-module__pHnz5G__editAndCommentContainer",
  "expired": "LorryCard-module-scss-module__pHnz5G__expired",
  "footerSectionContainer": "LorryCard-module-scss-module__pHnz5G__footerSectionContainer",
  "footerSectionWrapper": "LorryCard-module-scss-module__pHnz5G__footerSectionWrapper",
  "icon": "LorryCard-module-scss-module__pHnz5G__icon",
  "loadingState": "LorryCard-module-scss-module__pHnz5G__loadingState",
  "lorryActions": "LorryCard-module-scss-module__pHnz5G__lorryActions",
  "lorryBadgeCol": "LorryCard-module-scss-module__pHnz5G__lorryBadgeCol",
  "lorryCardContainer": "LorryCard-module-scss-module__pHnz5G__lorryCardContainer",
  "lorryCardSpaceWrapper": "LorryCard-module-scss-module__pHnz5G__lorryCardSpaceWrapper",
  "lorryClassification": "LorryCard-module-scss-module__pHnz5G__lorryClassification",
  "lorryClassificationCol": "LorryCard-module-scss-module__pHnz5G__lorryClassificationCol",
  "lorryClassificationContainer": "LorryCard-module-scss-module__pHnz5G__lorryClassificationContainer",
  "lorryCommentCol": "LorryCard-module-scss-module__pHnz5G__lorryCommentCol",
  "lorryIcon": "LorryCard-module-scss-module__pHnz5G__lorryIcon",
  "lorryIconCol": "LorryCard-module-scss-module__pHnz5G__lorryIconCol",
  "lorryId": "LorryCard-module-scss-module__pHnz5G__lorryId",
  "lorryNumber": "LorryCard-module-scss-module__pHnz5G__lorryNumber",
  "lorryNumberContainer": "LorryCard-module-scss-module__pHnz5G__lorryNumberContainer",
  "lorryPostedCol": "LorryCard-module-scss-module__pHnz5G__lorryPostedCol",
  "lorrySrcDestCol": "LorryCard-module-scss-module__pHnz5G__lorrySrcDestCol",
  "mainRow": "LorryCard-module-scss-module__pHnz5G__mainRow",
  "payBtnRedirection": "LorryCard-module-scss-module__pHnz5G__payBtnRedirection",
  "postedAt": "LorryCard-module-scss-module__pHnz5G__postedAt",
  "profileInfoWrapper": "LorryCard-module-scss-module__pHnz5G__profileInfoWrapper",
  "profileWrapper": "LorryCard-module-scss-module__pHnz5G__profileWrapper",
  "reActivate": "LorryCard-module-scss-module__pHnz5G__reActivate",
  "reActivateCol": "LorryCard-module-scss-module__pHnz5G__reActivateCol",
  "reactivateContainer": "LorryCard-module-scss-module__pHnz5G__reactivateContainer",
  "sentOrReceived": "LorryCard-module-scss-module__pHnz5G__sentOrReceived",
  "shareIcon": "LorryCard-module-scss-module__pHnz5G__shareIcon",
  "srcDestCol": "LorryCard-module-scss-module__pHnz5G__srcDestCol",
  "status": "LorryCard-module-scss-module__pHnz5G__status",
  "statusContainer": "LorryCard-module-scss-module__pHnz5G__statusContainer",
  "timeStamp": "LorryCard-module-scss-module__pHnz5G__timeStamp",
  "verifiedPill": "LorryCard-module-scss-module__pHnz5G__verifiedPill",
  "viewDetailsBtn": "LorryCard-module-scss-module__pHnz5G__viewDetailsBtn",
});
